export default {
  apiKey: "AIzaSyAs_H3vjPihU76bu_bZXd5zyVl5U4eIBWc",
  authDomain: "jmjsistemaseconsultoria.firebaseapp.com",
  databaseURL: "https://jmjsistemaseconsultoria.firebaseio.com",
  projectId: "jmjsistemaseconsultoria",
  storageBucket: "jmjsistemaseconsultoria.appspot.com",
  messagingSenderId: "184960648793",
  appId: "1:184960648793:web:85b7d4d1f2bec96fa29348",
};
